<template>
  <div style="background: #E3EDF6;padding: 8px;">
    <div class="openAcctAgreement">
      <p class="openAcctAgreement-title">公开募集证券投资基金<br>客户维护费揭示</p>
      <p class="xieyicontent" style="margin-top: 50px;">在您通过本机构持有【<span>{{message.FullName}}</span>】的整段投资期内， 本机构最高向基金管理人收取管理费的【<span>{{message.MaxRate}}</span>】作为客户维护费。</p>
      <p class="xieyicontent">客户维护费指基金管理人与基金销售机构通过基金销售协议约定，依据销售机构销售基金的保有量，从基金管理费中列支一定比例，用以向基金销售机构支付客户服务及销售活动中产生的相关费用。</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fundcode: '',
      message: ''
    }
  },
  created () {
    this.fundcode = this.$route.query.fundcode
  },
  mounted () {
    this.getFundDetailInfo()
  },
  methods: {
    getFundDetailInfo () {
      this.$http.get(this.$apiPath.getFundDetailInfo3, {
        InputFundValue: this.fundcode
      }).then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.message = res.data[0]
        }
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
</style>